export class TradeshowFormRequest {
    firstName?: string;
    lastName?: string;
    email?: string;
    company?: string;
    businessType?: string;
    state?: string;
    referral?: string;
    interests?: string;
    emailTos?: string[];
}
